class ColetoresModalController {
    constructor(api, modalInstance) {
        this.api = api
        this.modalInstance = modalInstance

        this.loadPromise = this.load()
    }

    async load() {
        let {data: {coletores}} = await this.api.get("/empresas/coletores")

        this.coletores = coletores
    }

    close() {
        this.modalInstance.dismiss()
    }
}

angular.module("eficienciaFiscalModule").controller("coletoresModalController", ["api", "$uibModalInstance", ColetoresModalController])